import { buildStoredImagePath } from "@reciperoll/core";
import { supabase } from "../lib/supabase";
import { resizeImageFile } from "./resizeImage";

// Upload a user-picked cover image to the collection-images bucket under their
// own folder (`${userId}/${collectionId}.jpg`, matching the RN convention + RLS).
// The user's own local File, uploaded from the browser — no CORS. The bucket is
// private, so we store the object PATH (version-stamped with ?t=) via
// setCollectionImageUploaded and sign it on display, rather than a public URL.
export async function uploadCollectionImage(
  userId: string,
  collectionId: string,
  file: File,
): Promise<string> {
  const path = `${userId}/${collectionId}.jpg`;
  const body = await resizeImageFile(file);
  const { error } = await supabase.storage
    .from("collection-images")
    .upload(path, body, {
      contentType: "image/jpeg",
      cacheControl: "31536000", // 1-year immutable; ?t= version-stamps the stored path
      upsert: true,
    });
  if (error) throw error;

  return buildStoredImagePath("collection-images", userId, collectionId);
}
